import { axiosRequest } from '@/plugins/axios-common'

import { handleError } from '@/store/handle-error'

import { AccountRecoveryActions } from './partials/account-recovery'
import { AccountVerificationActions } from './partials/account-verification'
import { UserProfileActions } from './partials/user-profile'

export const UserActions = {
  ...AccountRecoveryActions,
  ...AccountVerificationActions,
  ...UserProfileActions,

  getUser (_, userId) {
    return axiosRequest.get(`/users/${userId}`).
      then(({ data }) => data.user).
      catch(handleError)
  },

  requestUserEmailAddressVerification: async (_, { emailAddressId, userId }) => {
    return axiosRequest.
      post(`/users/${userId}/emails/${emailAddressId}/verify`).
      then(({ data }) => data).
      catch(handleError)
  },

  clearUserTOTPConfiguration: async ({ commit }, { userId }) => {
    return axiosRequest.
      delete(`/users/${userId}/totp`).
      then(({ data }) => {
        commit('setUserProfile', data.user)
      }).
      catch(handleError)
  },

  generateUserTOTPConfiguration: async (_, { userId }) => {
    return axiosRequest.
      get(`/users/${userId}/totp`).
      then(({ data }) => data).
      catch(handleError)
  },

  confirmUserTOTPConfiguration: async ({ commit }, { userId, secret, passcode }) => {
    return axiosRequest.
      post(`/users/${userId}/totp`, {
        totp: {
          passcode,
          secret,
        },
      }).
      then(({ data }) => {
        commit('setUserProfile', data.user)
      }).
      catch(handleError)
  },
}
